import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import config from '../config'

Vue.use(Vuex)

const initialState = {
  images: {}
}

const getters = {
  images: state => state.images,
  image: state => imageId => state.images[imageId]
}

const mutations = {
  image: (state, image) => {
    Vue.set(state.images, image.id, image)
  },
  images: (state, images) => {
    state.images = images
  }
}

const refreshImage = async (commit, imageId) => {
  if (imageId != null) {
    const response = await axios.get(`${config.getRootApi()}/images/${imageId}`)
    commit('image', { id: imageId, visual: response.data })
  }
}

const actions = {
  async fetchImage({ commit, state }, imageId) {
    const image = state.images[imageId]
    if (!!imageId && !image) {
      await refreshImage(commit, imageId)
    }
    return state.images[imageId]
  },
  async refreshImage({ commit }, imageId) {
    await refreshImage(commit, imageId)
  }
}

export default {
  state: initialState,
  getters,
  mutations,
  actions
}
